import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { apiThatThrows } from "../api";

export function useDevicesApi() {
  const dispatch = useDispatch();

  const exportDeviceModelApplicationsPaginated = useCallback(
    async (queryParams, forAdmin) => {
      if (forAdmin) {
        await dispatch(
          apiThatThrows.exportDeviceModelApplicationsPaginated.action({
            queryParams,
          })
        );
      } else {
        await dispatch(
          apiThatThrows.exportMyDeviceModelApplicationsPaginated.action({
            queryParams,
          })
        );
      }
    },
    [dispatch]
  );

  const getDeviceFamily = useCallback(
    async (id, forAdmin) => {
      let response;

      if (forAdmin) {
        response = await dispatch(
          apiThatThrows.getDeviceFamily.action({
            params: { id },
          })
        );
      } else {
        response = await dispatch(
          apiThatThrows.getMyDeviceFamily.action({
            params: { id },
          })
        );
      }
      return response?.results;
    },

    [dispatch]
  );

  const getDeviceModel = useCallback(
    async (id, forAdmin) => {
      let response;
      if (forAdmin) {
        response = await dispatch(
          apiThatThrows.getDeviceModel.action({
            params: { id },
          })
        );
      } else {
        response = await dispatch(
          apiThatThrows.getMyDeviceModel.action({
            params: { id },
          })
        );
      }
      return response?.results;
    },

    [dispatch]
  );

  return {
    getDeviceFamily,
    getDeviceModel,
    exportDeviceModelApplicationsPaginated,
  };
}
